import { isoToFormat } from '~/app/utils/useIsoToFormat'
import { DateTime } from 'luxon'

type TimeFormat = {
  date: string
  time: string
}

/**
 * 시간 포맷
 * @param time
 * @param isDiffDays
 */
export const timeFormat = (time: string, isDiffDays?: boolean) => {
  const [hour, minutes] = time.split(':')
  return `${isDiffDays ? +hour + 24 : hour}:${minutes}`
}
/**
 * yyyy.MM.dd (ccc) HH:mm
 * @param date
 * @param time
 */
export const toFullDateWithDayOrWeek = ({ date, time }: TimeFormat): string => {
  return `${isoToFormat(`${date}T00:00:00`, 'yyyy.MM.dd (ccc)')} ${timeFormat(time)}`
}
export const toTimeWithPlusDay = ({ from, to }: { from: TimeFormat; to: string }) => {
  const dateTimeTo = DateTime.fromISO(to)
  const diff = dateTimeTo
    .endOf('day')
    .diff(DateTime.fromISO(`${from.date}T00:00:00`).endOf('day'), ['days'])
  return timeFormat(dateTimeTo.toFormat('HH:mm'), diff.days >= 1)
}
